
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-53099b3b&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UpdateCenterLeader.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UpdateCenterLeader.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-53099b3b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UpdateCenterLeader.vue"),
  /* scopeId */
  "data-v-53099b3b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Utilities/UpdateCenterLeader.vue
// module id = 673
// module chunks = 0